import type { FilePickerFileTypesKeys } from 'src/types/file';

export const DEFAULT_FILE_TYPES = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
] satisfies FilePickerFileTypesKeys[];

export const TABLE_ACCEPTED_FILE_TYPES = ['csv', 'xls', 'xlsx'] satisfies FilePickerFileTypesKeys[];
